angular.module('app').controller('CustomerCtrl', function($controller, $scope, $mdDialog, appUtils, $http) {
    "ngInject";

    var main = this;
    main.name = 'user';
    main.defaults = {
        'user_subjects': []
    }

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.addCredit = function() {
        appUtils.quickDialog('CreditCtrl', 'credit.html', {}).then(
            function(credit) {
                credit.franchise_id = main.item.franchise_id;
                main.item.credits.push(credit);
            }
        );
    };

    main.removeSubject = function(us) {
        return $http({
            'method': 'DELETE',
            'url': '/api/v1/admin/subject/' + us.subject_id + '/user/' + us.user_id,
        }).then(
            function(response) {
                appUtils.remove(us, 'subject_id', main.item.user_subjects);
            }
        );
    };

    main.addExistingSubject = function(subject) {
        if(!subject) {
            return;
        }

        main.item.user_subjects.push({
            'user_id': main.item.id,
            'subject_id': subject.id,
            'subject': subject
        });
        main.subjectToAdd = null;

    };

    main.addNewSubject = function() {
        var holder = [];
        appUtils.embedNew('SubjectCtrl', '/static/admin/templates/subject.html', holder).then(
            function() {
                var transformed = holder[0].subject;
                delete holder[0].subject;
                transformed.event_signups = [
                    holder[0]
                ];
                main.item.subjects.push(transformed);
            }
        );
    };

});
